const PRODUCT_TYPE_TEXT = {
  tires: 'tire',
  wheels: 'wheel'
};

export function getCategoryPageBreadcrumbs(pathname) {
  const [, productType, ...pathParts] =
    typeof pathname === 'string' ? pathname.split('/') : [];
  const productTypeText = PRODUCT_TYPE_TEXT[productType];

  if (!productTypeText || !pathParts[0]) {
    return [];
  }

  if (pathParts[0].toLowerCase() === 'brands') {
    if (!pathParts[1]) {
      return [];
    }

    return [
      {
        name: `all ${productTypeText} brands`,
        url: `/${productType.toLowerCase()}/brands`
      }
    ];
  }

  return [
    {
      name: `all ${productTypeText} categories`,
      url: `/${productType.toLowerCase()}`
    }
  ];
}

export function getCategoryURL(path, showStaggeredURL) {
  if (showStaggeredURL && path.includes('catalog')) {
    const splitPath = path.split('?');
    return `${splitPath[0]}/sets?${splitPath[1] ?? ''}`;
  } else {
    return path;
  }
}
